import { HttpClient, HttpHandler, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import { Injectable, Inject } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { ObjectWrapper } from '../models/ObjectWrapper';
import { User } from '../models/User';
import { FilterObject } from '../models/FilterObject';
import { InfoCenterFile } from '../models/InfoCenterFile';
import { RMAResponse } from '../models/RMAResponse';
import { PagingResults } from '../models/PagingResult';
import { NewsItem } from '../models/NewsItem';
import { ReportRequestObject } from '../models/ReportRequestObject';
import { Category } from '../models/Category';
import { RMAItem } from '../models/RMAItem';
import { UserActivity } from '../models/UserActivity';

const httpOptions = {
  headers: new HttpHeaders({
    'Content-type': 'application/json',
    'Authorization': 'my-auth-token'
  })
}

@Injectable({
  providedIn: "root"
})
export class HttpService {
  base: string;
  constructor(private client: HttpClient, @Inject('BASE_URL') baseUrl: string) {
    this.base = baseUrl;
    //this.base = "http://localhost:43464/";
  }

  //account section
  RefreshCookies():Promise<ObjectWrapper> {
    return this.client.get<ObjectWrapper>(this.base + "api/Account/RefreshCookies", httpOptions).toPromise();
  }

  UserLogin(username: string, password: string): Promise<ObjectWrapper> {
    var loginUser = new User();
    loginUser.Email = username;
    loginUser.Password = password
    return this.client.post<ObjectWrapper>(this.base + "api/Account/Userlogin", loginUser, httpOptions).toPromise();
  }

  CreateUser(newUser: User): Promise<ObjectWrapper> {
    return this.client.post<ObjectWrapper>(this.base + "api/Account/CreateUser", newUser, httpOptions).toPromise();
  }

  UpdateUser(newUser: User): Promise<ObjectWrapper> {
    return this.client.post<ObjectWrapper>(this.base + "api/Account/UpdateUser", newUser, httpOptions).toPromise();
  }

  GetUserById(userID: string): Promise<ObjectWrapper> {
    return this.client.get<ObjectWrapper>(this.base + "api/Account/GetUserById/" + userID, httpOptions).toPromise();
  }

  GetUsers(pageIndex: number, pageSize: number, filterList: FilterObject[], userid:string): Promise<ObjectWrapper> {
    return this.client.post<ObjectWrapper>(this.base + "api/Account/GetUsers/" + userid + "/" + pageIndex.toString() + "/" + pageSize.toString(), filterList, httpOptions).toPromise();
  }

  GetUsersNames(): Promise<ObjectWrapper> {
    return this.client.get<ObjectWrapper>(this.base + "api/Account/GetUsersNames", httpOptions).toPromise();
  }

  ResetPassword(user: User): Promise<ObjectWrapper> {
    return this.client.post<ObjectWrapper>(this.base + "api/Account/ResetPassword", user, httpOptions).toPromise();
  }

  verifyUserReset(userid: string): Promise<ObjectWrapper> {
    return this.client.get<ObjectWrapper>(this.base + "api/Account/VerifyResetPassword/" + userid, httpOptions).toPromise();
  }

  verifyUserEmail(userid: string): Promise<ObjectWrapper> {
    return this.client.get<ObjectWrapper>(this.base + "api/Account/VerifyEmail/" + userid, httpOptions).toPromise();
  }

  ForgotPassword(user: User): Promise<ObjectWrapper> {
    return this.client.post<ObjectWrapper>(this.base + "api/Account/ForgotPassword", user, httpOptions).toPromise();
  }

  sendVerificationEmail(user: User): Promise<ObjectWrapper> {
    return this.client.post<ObjectWrapper>(this.base + "api/Account/SendEmailVerification", user, httpOptions).toPromise();
  }

  GetDistributors(): Promise<ObjectWrapper> {
    return this.client.get<ObjectWrapper>(this.base + "api/Account/GetDistributors", httpOptions).toPromise();
  }

  //end account section
  GetRMA(filter: FilterObject[], userID: string, pageIndex: number, pageSize: number,sort:string): Promise<ObjectWrapper> {
    return this.client.post<ObjectWrapper>(this.base + "api/RMA/GetRMA/" + userID + "/" + pageIndex + "/" + pageSize + "/" + sort, filter, httpOptions).toPromise();
  }

  GetRMAItems(rmaNum: string, userID: string): Promise<ObjectWrapper> {
    return this.client.get<ObjectWrapper>(this.base + "api/RMA/GetRMAItems/" + rmaNum + "/" + userID, httpOptions).toPromise();
  }

  SubmitRMAResponse(response:RMAResponse,curUser:string):Promise<ObjectWrapper> {
    var formData = new FormData();

    formData.append('Action', response.Action);
    formData.append('CustomerResponse', response.CustomerResponse);
    //formData.append('DateSubmitted', response.DateSubmitted.toUTCString());
    formData.append('POFileName', response.POFileName);
    formData.append('PONumber', response.PONumber);
    formData.append('RMAItemRowPointer', response.RMAItemRowPointer);
    formData.append('RMANumber', response.RMANumber);
    formData.append('RMAResponseID', response.RMAResponseID);
    formData.append('TakenByEmail', response.TakenByEmail);
    formData.append('UserID', response.UserID);

    if (response.POFileName && response.POFileName.length > 0) {
      formData.append('POFile', response.POFile, response.POFileName);
      return this.client.post<ObjectWrapper>(this.base + "api/RMA/SubmitResponseWithFile/" + curUser, formData).toPromise();
    }
    else {
      return this.client.post<ObjectWrapper>(this.base + "api/RMA/SubmitResponse/" + curUser, formData).toPromise();
    }    
  }


  FollowRMA(follow: boolean, rmaItemRowPointer: string, userID: string):Promise<ObjectWrapper> {
    return this.client.get<ObjectWrapper>(this.base + "api/RMA/OptInToUpdates/" + userID + "/" + rmaItemRowPointer + "/" + follow).toPromise();
  }

  DownloadRMAEvaluation(rmaNumber: RMAItem) {
    try {
      return this.client.post(this.base + "api/RMA/Evaluation", rmaNumber,{ responseType: 'blob', observe: 'response' });
    }
    catch (err) {

      var message = err.message;
      return null;
    }
  }

  DownloadRMAVerification(rmaNumber: string) {
    try {
      return this.client.get(this.base + "api/RMA/Verification/" + rmaNumber , { responseType: 'blob', observe: 'response' });
    }
    catch (err) {
      
      var message = err.message;
      return null;
    }
    
  }

  DownloadOrderVerification(orderNumber: string) {
    try {
      return this.client.get(this.base + "api/Order/Verification/" + orderNumber, { responseType: 'blob', observe: 'response' });
    }
    catch (err) {
      
      var message = err.message;
      return null;
    }

  }

  DownloadInvoice(invoice: string) {
    try {
      var retItem = this.client.get(this.base + "api/Order/Invoice/" + invoice, { responseType: 'blob', observe: 'response' });
      return retItem;
    }
    catch (err) {

      var message = err.message;
      return null;
    }

  }

  GetOrders(filter: FilterObject[], userID: string, pageIndex: number, pageSize: number, sort:string): Promise<ObjectWrapper> {
    return this.client.post<ObjectWrapper>(this.base + "api/Order/GetOrders/" + userID + "/" + pageIndex + "/" + pageSize + "/" + sort, filter, httpOptions).toPromise();
  }

  FollowOrderDetail(follow: boolean, orderDetailRowPointer: string, userID:string):Promise<ObjectWrapper> {
    return this.client.get<ObjectWrapper>(this.base + "api/Order/OptInToUpdates/" + userID + "/" + orderDetailRowPointer + "/" + follow).toPromise();
  }

  GetQuotes(filter: FilterObject[], userID: string, pageIndex: number, pageSize: number, sort:string): Promise<ObjectWrapper> {
    return this.client.post<ObjectWrapper>(this.base + "api/Order/GetQuotes/" + userID + "/" + pageIndex + "/" + pageSize + "/" + sort, filter, httpOptions).toPromise();
  }

  GetQuoteDetails(quotenumber: string, userID: string) {
    return this.client.get<ObjectWrapper>(this.base + "api/Order/GetQuoteDetail/" + quotenumber + "/" + userID, httpOptions).toPromise();
  }

  GetOrderDetails(orderNum: string, userID:string): Promise<ObjectWrapper> {
    return this.client.get<ObjectWrapper>(this.base + "api/Order/GetOrderDetail/" + orderNum + "/" + userID, httpOptions).toPromise();
  }

  async PostUserActivity(userID: string, page: string, action: string, actionValue:string) {
    var activity = new UserActivity();
    activity.UserID = userID;
    activity.Page = page;
    activity.Action = action;
    activity.ActionValue = actionValue;
    
    return await this.client.post<ObjectWrapper>(this.base + "api/UserActivity/PostActivity", activity, httpOptions).toPromise();
  }

  GetUserActivity(filter: FilterObject[], userID: string, pageIndex: number, pageSize: number): Promise<ObjectWrapper> {
    return this.client.post<ObjectWrapper>(this.base + "api/UserActivity/GetActivity/" + userID + "/" + pageIndex + "/" + pageSize, filter, httpOptions).toPromise();
  }
  /*Info Center */
  GetInfoCenterFilesForUser(filter: FilterObject[], userID: string, pageIndex: number, pageSize: number): Promise<ObjectWrapper> {
    return this.client.post<ObjectWrapper>(this.base + "api/InfoCenter/GetInfoCenterContent/" + userID + "/" + pageIndex + "/" + pageSize, filter, httpOptions).toPromise();
  }

  GetAllInfoCenterFiles(filter: FilterObject[],userid: string):Promise<ObjectWrapper> {
    return this.client.post<ObjectWrapper>(this.base + "api/InfoCenter/GetAllFiles/" + userid, filter, httpOptions).toPromise();
  }

  GetInfoCenterFilesForAdmin(filter: FilterObject[], userID: string, pageIndex: number, pageSize: number): Promise<ObjectWrapper> {
    return this.client.post<ObjectWrapper>(this.base + "api/InfoCenter/GetInfoCenterForAdmin/" + userID + "/" + pageIndex + "/" + pageSize, filter, httpOptions).toPromise();
  }

  FollowDocument(follow: boolean, infoCenterID: string, userID: string):Promise<ObjectWrapper> {
    return this.client.get<ObjectWrapper>(this.base + "api/InfoCenter/OptInToUpdates/" + userID + "/" + infoCenterID + "/" + follow).toPromise();
  }

  UpdateFileIndex(file: InfoCenterFile): Promise<ObjectWrapper> {
    return this.client.post<ObjectWrapper>(this.base + "api/InfoCenter/UpdateFileIndex", file, httpOptions).toPromise();
  }
  UpdateNewsItemSortOrder(file: NewsItem): Promise<ObjectWrapper> {
    return this.client.post<ObjectWrapper>(this.base + "api/News/UpdateNewsItemSortOrder", file, httpOptions).toPromise();
  }

  UpdateCategorySortOrder(cat: Category): Promise<ObjectWrapper> {
    return this.client.post<ObjectWrapper>(this.base + "api/InfoCenter/UpdateCategorySortOrder", cat, httpOptions).toPromise();
  }

  DeleteInfoCenterFile(fileID: string) {
    return this.client.get<ObjectWrapper>(this.base + "api/InfoCenter/DeleteFile/" + fileID, httpOptions).toPromise();
  }
  UploadInfoCenterFile(fileFormData: InfoCenterFile, userID: string): Promise<ObjectWrapper> {
    var formData = new FormData();
    if (fileFormData.Type == "upload" && fileFormData.FileData != null) {
      formData.append('FileData', fileFormData.FileData, fileFormData.FileName);
    }
    formData.append('FullPath', fileFormData.FullPath);
    formData.append('FileName', fileFormData.FileName);
    formData.append('EnabledFor', fileFormData.EnabledFor);
    formData.append('Active', fileFormData.Active.toString());
    formData.append('Category', fileFormData.Category.toString());
    formData.append('Description', fileFormData.Description);
    formData.append('FileType', fileFormData.FileType);
    formData.append('Type', fileFormData.Type);
    formData.append('InfoCenterFileID', fileFormData.InfoCenterFileID);
    
    return this.client.post<ObjectWrapper>(this.base + "api/InfoCenter/UploadFile/" + userID, formData).toPromise();

  }

  DownloadInfoCenterFile(userid: string, fileid: string): Observable<HttpResponse<Blob>> {
    try {
      return this.client.get(this.base + "api/InfoCenter/DownloadFile/" + userid + "/" + fileid, { responseType: 'blob', observe: 'response' });
    }
    catch (err) {
      
      var message = err.message;
      return null;
    }
  }

  PreviewFile(fileID: string) {
    return this.client.get<Blob>(this.base + "api/InfoCenter/PreviewFile/" + fileID, { responseType: 'blob' as 'json' })
      .pipe(
      map((res:any) => {
        return new Blob([res], { type: 'application/pdf' });
      }));
  }

  SaveCategory(cat: Category):Promise<ObjectWrapper> {
    return this.client.post<ObjectWrapper>(this.base + "api/InfoCenter/SaveCategory", cat, httpOptions).toPromise();
  }

  DeleteCategory(del: number): Promise<ObjectWrapper> {
    return this.client.get<ObjectWrapper>(this.base + "api/InfoCenter/DeleteCategory/" + del, httpOptions).toPromise();
  }

  GetCategories(type: string):Promise<ObjectWrapper> {
    return this.client.get<ObjectWrapper>(this.base + "api/InfoCenter/GetCategories/" + type, httpOptions).toPromise();
  }


  /* News Items */

  GetNewsItems(pageIndex:number,pageSize:number ): Promise<PagingResults> {
    return this.client.get<PagingResults>(this.base + "api/News/GetNewsFeed/" + pageIndex.toString() + "/" + pageSize.toString(), httpOptions).toPromise();
  }

  GetTolomaticRSSFeed(): Promise<ObjectWrapper> {
    debugger;
    try {
      return this.client.get<ObjectWrapper>(this.base + "api/News/GetTolomaticRSS", httpOptions).toPromise();
    } catch (er) {
      console.log(er);
    }
    
  }

  //GetNewsItemsAdmin(pageIndex:number, pageSize:number):Promise<PagingResults> {
  //  return this.client.get<PagingResults>(this.base + "api/News/GetNewsItemsAdmin/", httpOptions).toPromise();
  //}

  AddNewsItem(item: NewsItem):Promise<ObjectWrapper> {
    return this.client.post<ObjectWrapper>(this.base + "api/News", item, httpOptions).toPromise();
  }

  DeleteNewsItem(itemID: number, userID:string):Promise<ObjectWrapper> {
    return this.client.get<ObjectWrapper>(this.base + "api/News/DeleteNewsItem/" + itemID.toString() + "/" + userID, httpOptions).toPromise();
  }

  /*Pricing*/
  BuildConfigString() {

  }

  ItemSearch(filter: FilterObject[], pageIndex: number, pageSize: number): Promise<PagingResults> {
    return this.client.post<PagingResults>(this.base + "api/Pricing/ItemSearch/" + pageIndex.toString() + "/" + pageSize.toString(), filter, httpOptions).toPromise();
  }

  AdvancedItemSearch(filter: FilterObject[], pageIndex: number, pageSize: number): Promise<PagingResults> {
    return this.client.post<PagingResults>(this.base + "api/Pricing/AdvancedItemSearch/" + pageIndex.toString() + "/" + pageSize.toString(), filter, httpOptions).toPromise();
  }

  GetBreakPricing(cust: string, item: string): Promise<ObjectWrapper> {
    return this.client.get<ObjectWrapper>(this.base + "api/Pricing/GetBreakPricing/" + cust + "/" + item, httpOptions).toPromise();
  }

  GetPricing(config:string):Promise<ObjectWrapper> {
    return this.client.get<ObjectWrapper>(this.base + 'api/Pricing/GetPricing/' + config, httpOptions).toPromise();
  }

  GetEstimatedLeadTimeMessage(): Promise<ObjectWrapper> {
    return this.client.get<ObjectWrapper>(this.base + 'api/Pricing/GetEstimatedLeadTimeVerbiage', httpOptions).toPromise();
  }

  GetTariffMessage(): Promise<ObjectWrapper> {
    return this.client.get<ObjectWrapper>(this.base + 'api/Pricing/GetTariffMessage', httpOptions).toPromise();
  }

  //CPQ Options section
  //Call this first for the session
  CPQConfigureStart(configString: string, forceReset: boolean): Promise<ObjectWrapper> {
    var configObject = {
      ConfigString: configString,
      ForceReset: forceReset
    }
    
    return this.client.post<ObjectWrapper>(this.base + "api/CPQ/StartConfiguration", configObject, httpOptions).toPromise();
  }


  //Call this second to initialize
  CPQInitialize(sessionID: string) {
    return this.client.get<ObjectWrapper>(this.base + "api/CPQ/InitializeCPQ/" + sessionID, httpOptions).toPromise();
  }


  //Call this to get UI
  //First only send sessionID
  //Subsequent calls will need sessionID, id of control, new value selection
  //CPQConfigureUpdate(sessionID:string,cpq:CPQUI):Promise<ObjectWrapper> {
  CPQConfigureUpdate(sessionID: string, id: string, value: string): Promise<ObjectWrapper> {
    var updateObj = {
      sessionID: sessionID,
      id: id,
      value: value
    }
    return this.client.post<ObjectWrapper>(this.base + "api/CPQ/UpdateConfiguration", updateObj, httpOptions).toPromise();
  }

  GetSQLReport(reportParams: ReportRequestObject): Observable<HttpResponse<Blob>> {
    var headers = new HttpHeaders().set('Accept', 'application/pdf');
    try {
      return this.client.post(this.base + "api/Report/GetReport", reportParams, { headers, responseType: 'blob', observe: 'response' });//, observe: 'response'
      //return this.client.get(this.base + "api/InfoCenter/DownloadFile/" + userid + "/" + fileid, { responseType: 'blob', observe: 'response' });
    }
    catch (er) {
      return null;
    }
  }

  LoadNewsItems(numberOfItems:number):Promise<PagingResults> {
    return this.client.get<PagingResults>(this.base + "api/News/GetNewsFeed/0/" + numberOfItems.toString(), httpOptions).toPromise();
  }
}
